import { Card } from '../ui/Card';
import { config } from '../../lib/config';
import { Sparkles, Zap, Shield, Users, Bot, MessageSquare, Brain, Code2 } from 'lucide-react';

function AboutInfo() {
  const features = [
    {
      icon: Brain,
      title: 'Inteligência Artificial Avançada',
      description: 'Assistentes virtuais com capacidade de aprendizado e compreensão contextual.'
    },
    {
      icon: MessageSquare,
      title: 'Integração com WhatsApp',
      description: 'Conecte múltiplas contas do WhatsApp e automatize seus atendimentos.'
    },
    {
      icon: Bot,
      title: 'Assistentes Especializados',
      description: 'Assistentes treinados para diferentes segmentos e necessidades específicas.'
    },
    {
      icon: Shield,
      title: 'Segurança e Privacidade',
      description: 'Dados criptografados e conformidade com as normas de proteção de dados.'
    },
    {
      icon: Users,
      title: 'Multiusuário',
      description: 'Gerencie múltiplos usuários com diferentes níveis de acesso.'
    },
    {
      icon: Zap,
      title: 'Alta Performance',
      description: 'Sistema otimizado para respostas rápidas e processamento eficiente.'
    },
    {
      icon: Code2,
      title: 'APIs e Integrações',
      description: 'Conecte-se com outros sistemas e expanda as funcionalidades.'
    },
    {
      icon: Sparkles,
      title: 'Experiência Personalizada',
      description: 'Interface intuitiva e adaptável às suas necessidades.'
    }
  ];

  return (
    <Card className="p-6">
      <div className="flex flex-col items-center justify-center py-8">
        <img
          src="/logo.png"
          alt={config.name}
          className="h-16 mb-8"
        />
        
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          {config.name} - {config.description}
        </h2>
        
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl text-center mb-12">
          Uma plataforma completa para gerenciamento de assistentes virtuais e automação de processos com inteligência artificial. Transforme seu atendimento com tecnologia de ponta e experiências personalizadas.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-6xl">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-md transition-shadow"
            >
              <feature.icon className="h-8 w-8 text-primary-600 dark:text-primary-400 mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 space-y-4 text-center">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Informações da Empresa
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              <a 
                href={config.company.website} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-700 dark:text-primary-400"
              >
                {config.company.name}
              </a>
            </p>
            <p className="text-gray-600 dark:text-gray-300">
              {config.company.contact.phone}
            </p>
          </div>

          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Endereço
            </h3>
            <address className="text-gray-600 dark:text-gray-300 not-italic">
              {config.company.contact.address.street}, {config.company.contact.address.number}<br />
              {config.company.contact.address.neighborhood}<br />
              {config.company.contact.address.city} - {config.company.contact.address.state}<br />
              CEP: {config.company.contact.address.zipCode}
            </address>
          </div>

          <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Versão {config.version}
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {config.company.copyright}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default AboutInfo;